export var slice = [].slice;



//////////////////
// WEBPACK FOOTER
// /Users/ryan/Projects/texastribune/primary-early-vote-tracker-2018/node_modules/d3-queue/src/array.js
// module id = null
// module chunks = 